import { render, staticRenderFns } from "./fun.vue?vue&type=template&id=50615e5f&scoped=true&"
import script from "./fun.vue?vue&type=script&lang=js&"
export * from "./fun.vue?vue&type=script&lang=js&"
import style0 from "./fun.vue?vue&type=style&index=0&id=50615e5f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50615e5f",
  null
  
)

export default component.exports